// Event create page (comp-ε GAP-3b-ii-b, CHG-2450).
//
// Thin route wrapper at /events/new that renders the canonical
// EventFormDialog (mode=create). The FormDialog is a full-viewport overlay;
// the page provides the <main role="main"> landmark (AppShell intentionally
// has no <main> — events-v2.cross-screen.yaml accessibility contract). On
// create the route navigates to the new event's detail; on cancel/close it
// returns to the events list.
//
// Spec: specs/tier-05-experience/events-v2.cross-screen.yaml.

import { useNavigate } from "react-router-dom";
import { EventFormDialog } from "../components/events/EventFormDialog";

export function EventCreate() {
  const navigate = useNavigate();
  return (
    <main role="main">
      <EventFormDialog
        mode="create"
        onClose={() => navigate("/events")}
        onSaved={(saved) => navigate(`/events/${saved.id}`)}
      />
    </main>
  );
}
